import 'babel-polyfill';
import {instance} from '../utils/axiosInstance'


export class AuthApi {
    static async logout(token) {
        return instance.delete('/refresh_token', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    }

    static async getToken(user, password) {
        return instance.post('/token', {
            user,
            password
        })
    }

    static async refreshToken(refreshToken) {
        return await instance.put('/refresh_token', {
            headers: {
                'Authorization': `Bearer ${refreshToken}`
            }
        })
    }

}



// WEBPACK FOOTER //
// ./src/api/auth_api.js